module.exports = __webpack_public_path__ + "img/main-sec-img.6e997cb6.webp";